module.exports = __webpack_public_path__ + "7ad29600c3a3c2a2e4179812ff0b57f1.fbx";